import PropTypes from 'prop-types';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';

import { KMP_CAMPAIGN_SETTINGS, KMP_DISTRIBUTE_CONTACTS } from 'features/common/acl/constants';
import CampaignsList from 'pages/CampaignsList';

import PageLayout from '../components/PageLayout';

const CampaignsListPage = ({ type }) => {
	return (
		<PageLayout>
			<div className="Page-main">
				<AccessControl
					accessLevel={type === 'MANAGEMENT' ? KMP_DISTRIBUTE_CONTACTS : KMP_CAMPAIGN_SETTINGS}
					showAccessDenied
				>
					<CampaignsList />
				</AccessControl>
			</div>
		</PageLayout>
	);
};

CampaignsListPage.propTypes = {
	type: PropTypes.string,
};
export default CampaignsListPage;
